import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { Select, Button, Col, Spin, DatePicker, Row } from "antd";
import { DownOutlined } from '@ant-design/icons';
import './Chart.css';
import { DualAxesChart, DualAxesChartProps, ColumnChart } from "@opd/g2plot-react";
import { getGraphDetails } from "../../../../redux/actions";
import moment from 'moment';
import { timesheetGraphReducer } from "../../../../redux/reducers/TimesheetReducer";


const Chart = (props) => {
  const pageSize = 10;
  const skip = 0;
  const { RangePicker } = DatePicker;
  const dispatch = useDispatch();
  const [reportTime, setReportTime] = useState('Till date');
  const [reportRange, setReportRange] = useState('');
  const [StartTime, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [absent, setTotalAbsents] = useState('0');
  const [earning, setTotalLearning] = useState('0');
  const [present, settotalPresent] = useState('0');
  const [overtime, setOvertime] = useState('0');
  const [firstDay, setFirstDay] = useState('');
  const [lastDay, setLastDay] = useState('');
  const [monthfday, setMonthfDay] = useState('');
  const [monthLday, setMonthLDay] = useState('');
  const [firstdayofyr, setFirstdayofyr] = useState('');
  const [graphData, setGraphData] = useState([]);

  // const success = useSelector(state => state.timeSheetReducer.success);
  // const loading = useSelector(state => state.timeSheetReducer.loading);
  const details = useSelector(state => state.timesheetGraphReducer.details);

  const date = ['Till date', 'This Week', 'This Month', 'Custom']
  const data =
    [//value= totalPresent , Count= Overtime
      { time: '2019-03', value: 350, type: 'Total Present' },
      { time: '2019-04', value: 900, type: 'Total Present' },
      { time: '2019-05', value: 300, type: 'Total Present' },
      { time: '2019-06', value: 450, type: 'Total Present' },
      { time: '2019-07', value: 470, type: 'Total Present' },
      { time: '2019-03', value: 220, type: 'Total Absent' },
      { time: '2019-04', value: 300, type: 'Total Absent' },
      { time: '2019-05', value: 250, type: 'Total Absent' },
      { time: '2019-06', value: 220, type: 'Total Absent' },
      { time: '2019-07', value: 362, type: 'Total Absent' },
      { time: '2019-03', value: 220, type: 'Total Overtime' },
      { time: '2019-04', value: 300, type: 'Total Overtime' },
      { time: '2019-05', value: 250, type: 'Total Overtime' },
      { time: '2019-06', value: 220, type: 'Total Overtime' },
      { time: '2019-07', value: 362, type: 'Total Overtime' },
    ];
  const transformData = [
    // { time: '2019-03', },
    // { time: '2019-04', },
    // { time: '2019-05', },
    // { time: '2019-06', },
    // { time: '2019-07', },
    // { time: '2019-07', },
  ];
  const config2 = {
    // data: [reportTime === 'This Month'?graphData:graphData, transformData],
    data: [graphData ? graphData : transformData, transformData],
    xField: 'time',
    yField: ['value', 'count'],
    // data: [data, transformData],
    // renderer: 'canvas',
    // autoFit: 'true',
    // padding: 'auto',
    legend: false,
    seriesField: 'type',
    isGroup: true,
    geometryOptions: [
      {
        geometry: 'column',
        isGroup: true,
        seriesField: 'type',
        color: ['#4ec0b2', '#d3d3d3', '#4054b2'],
        columnStyle: {
          radius: [20, 20, 0, 0],
        }
      },
      {
        geometry: 'line',
        color: '#5AD8A6',
        lineStyle: {
          width: 1,
        }
      }
    ],
  };
  const convertMilliSecondtoHours = (milliseconds) => {
    return ((milliseconds / (1000 * 60 * 60)) % 24).toFixed(2);
  }

  useEffect(() => {
    var data2 = [];
    if (details.length && details[1].length) {
      for (var i = 0; i < details[1].length; i++) {
        data2 = [...data2,
        {
          time: moment(details[1][i].Date).format('MMMM DD, YYYY'), value: details[1][i].SpentTime, type: 'Total Present',
        },
        {
          time: moment(details[1][i].Date).format('MMMM DD, YYYY'), value: details[1][i].TotalAbsents, type: 'Total Absent',

        }, {
          time: moment(details[1][i].Date).format('MMMM DD, YYYY'), value: details[1][i].OverTime, type: 'Total Overtime',
        }]
      }
      setGraphData(data2);
    }
  }, [details])

  useEffect(() => {
    var curr = new Date;
    var first = curr.getDate() - curr.getDay();
    var last = first + 7;

    var firstday = new Date(curr.setDate(first)).toUTCString();
    setFirstDay(firstday);
    var lastday = new Date(curr.setDate(last)).toUTCString();
    setLastDay(lastday);
  }, [])

  useEffect(() => {
    var d = new Date(new Date().getFullYear(), 0, 1);
    setFirstdayofyr(d);
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    setMonthfDay(firstDay);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    setMonthLDay(lastDay);

  }, [])

  useEffect(() => {
    if (details.length) {
      setTotalAbsents(details[0].totalabsents);
      setTotalLearning(details[0].totalearning);
      settotalPresent(details[0].totalPresent);
      setOvertime(details[0].totalovertime);
    }
  }, [reportTime])

  const selectValue = (e) => {
    setReportTime(e);
  }
  const onCustomDate = (e) => {
    setReportRange(e);
    var StartTime = new Date(e[0]._d).toISOString();
    // console.log(startTime.toLocaleString());
    var endTime = new Date(e[1]._d).toISOString();
    setStartDate(StartTime);
    setEndDate(endTime);
    // dispatch(getGraphDataApi(startDate,endDate));
  }

  useEffect(() => {
    if (reportTime === 'This Week') {
      dispatch(getGraphDetails(props.userassignmentId, 'thisweek', firstDay, lastDay));
      // dispatch(fetchTimeSheetList(pageSize, skip,'thisweek',null,null))
    }
    if (reportTime === 'This Month') {
      dispatch(getGraphDetails(props.userassignmentId, 'thismonth', monthfday, monthLday));
      // dispatch(fetchTimeSheetList(pageSize, skip,'thismonth',null,null))
    }

    if (reportTime === 'Till date') {
      dispatch(getGraphDetails(props.userassignmentId, 'tilldate', null, null));
      // dispatch(fetchTimeSheetList(pageSize, skip,'tilldate',null,null))
    }
    else if (reportRange) {
      dispatch(getGraphDetails(props.userassignmentId, 'custom', StartTime, endDate));
      // dispatch(fetchTimeSheetList(pageSize, skip,'custom',StartTime,endDate))
    }
  }, [reportRange, reportTime]);

  return (
    <>
      <Col lg={24} className={'report-container'}>
        <Row>
          <Col xs={9} lg={5} md={5}>
            <Select style={{ width: '100%', border: '1px solid lightgray' }}
              defaultValue='Till Date'
              onChange={selectValue}
            >
              {date.map((selectDate, index) => {
                return <Select.Option key={index} value={selectDate}>{selectDate}</Select.Option>
              })}
            </Select>
          </Col>
          <Col xs={15} lg={8} md={8}>
            {
              reportTime == "Custom" ?
                <RangePicker style={{ width: '97%', marginLeft: "3%" }}
                  onChange={onCustomDate}
                  format={'MMMM DD, YYYY'}
                />
                :
                <DatePicker style={{ width: '97%', marginLeft: "3%" }}
                  // defaultValue={'Till Date'8
                  placeholder={
                    reportTime == "This Month" ? moment(monthfday).format('MMMM DD, YYYY') + '-' + moment(monthLday).format('MMMM DD, YYYY')
                      :
                      reportTime === 'This Week' ? moment(firstDay).format('MMMM DD, YYYY') + '-' + moment(lastDay).format('MMMM DD, YYYY')
                        :
                        reportTime === "Till date" ? moment(firstdayofyr).format('MMMM DD, YYYY') + '-' + moment().format('MMMM DD, YYYY')
                          : 'Select date'
                  }
                  disabledDate={(current) => {
                    return moment().add(-1, "days") >= current;
                  }}
                />
            }
          </Col>
        </Row>
        <Row className="Report-container-divs">
          <Col lg={12} className='report-first-two-div-container'>
            <div className="present-div">
              <div className='reporttext'>{details.length ? " " + details[0].totalpresent : present} hrs</div>
              <div className='div-detail'>Total present</div>
            </div>

            <div className='absent-div'>
              <div className='reporttext'>{details.length ? " " + details[0].totalabsents.toFixed(2) : absent} hrs</div>
              <div className='div-detail'>Total absent</div>
            </div>
          </Col>
          <Col lg={12} className='report-last-two-div-container'>
            <div className="Overtime-div">
              <div className='reporttext'>{details.length ? " " + details[0].totalovertime : overtime} hrs</div>
              <div className='div-detail'>Total overtime</div>
            </div>

            <div className='earning-div'>
              <div className='reporttext'>{details.length ? "$" + details[0].totalearning : earning} </div>
              <div className='div-detail'>Total earnings</div>
            </div>
          </Col>
        </Row>

        <Col lg={24} xs={24} className="chart-container">
          <>
            <Col xs={24} className={'Graph-detail-container'}>
              <Row><div className="present-circle"></div> <div className='Report-details'>Total present
                {details.length ? " " + details[0].totalpresent : present}
                hrs</div> </Row>
              <Row><div className="absent-circle"></div>   <div className='Report-details'>Total absent
                {details.length ? " " + details[0].totalabsents.toFixed(2) : absent}
                hrs</div> </Row>
              <Row><div className="Overtime-circle"></div>   <div className='Report-details'>Total overtime
                {details.length ? " " + details[0].totalovertime : earning}
                hrs</div> </Row>
            </Col>
            <DualAxesChart {...config2} />
          </>
        </Col>
      </Col>
    </>
  )
}
export default Chart;